import React from 'react';
import { MapContainer, TileLayer, Polyline, Marker, Popup } from 'react-leaflet';
import { divIcon } from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { MapBounds } from './MapBounds';
import { ROUTE_COLORS } from '../constants';
import { normalizeName } from '../route-calculator';
export function RouteMap({ routePath, routeCache, routeStops, selectedRouteIndex, alternativeRoutes, showAlternativeRoutes, selectedStationsCoords, firstStation, lastStation, routeVia, maxRoutesCount: MAX_ROUTES_COUNT }) {
    const pathsToShow = routePath && routePath.length > 0
        ? (selectedRouteIndex !== null && alternativeRoutes[selectedRouteIndex]
            ? [alternativeRoutes[selectedRouteIndex].path]
            : showAlternativeRoutes && alternativeRoutes.length > 0
                ? alternativeRoutes.slice(0, Math.min(MAX_ROUTES_COUNT, alternativeRoutes.length)).map(r => r.path)
                : [routePath])
        : undefined;
    const stationCoordsForBounds = selectedStationsCoords.length > 0
        ? selectedStationsCoords.map(s => ({ lat: s.lat, lon: s.lon }))
        : undefined;
    return (React.createElement("div", { style: {
            overflow: 'hidden',
            border: 'none',
            height: '400px',
            background: '#fff'
        } },
        React.createElement(MapContainer, { center: [55.169, 23.881], zoom: 7, scrollWheelZoom: true, style: { height: '100%', width: '100%' } },
            React.createElement(TileLayer, { attribution: "\u00A9 OpenStreetMap contributors", url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" }),
            React.createElement(MapBounds, { paths: pathsToShow, cache: routeCache, stationCoords: stationCoordsForBounds }),
            routePath && routePath.length > 0 && routeCache && (React.createElement(React.Fragment, null, selectedRouteIndex !== null && alternativeRoutes[selectedRouteIndex] ? (React.createElement(Polyline, { key: `selected-${selectedRouteIndex}`, positions: alternativeRoutes[selectedRouteIndex].path.map(nodeId => {
                    const node = routeCache.nodes.get(nodeId);
                    return node ? [node.lat, node.lon] : [0, 0];
                }).filter((coord) => coord[0] !== 0 || coord[1] !== 0), color: ROUTE_COLORS[selectedRouteIndex % ROUTE_COLORS.length], weight: 6, opacity: 0.95 })) : showAlternativeRoutes && alternativeRoutes.length > 0 ? (alternativeRoutes.slice(0, Math.min(MAX_ROUTES_COUNT, alternativeRoutes.length)).map((route, idx) => {
                const colorIdx = idx % ROUTE_COLORS.length;
                return (React.createElement(Polyline, { key: `route-${idx}`, positions: route.path.map(nodeId => {
                        const node = routeCache.nodes.get(nodeId);
                        return node ? [node.lat, node.lon] : [0, 0];
                    }).filter((coord) => coord[0] !== 0 || coord[1] !== 0), color: ROUTE_COLORS[colorIdx], weight: idx === 0 ? 5 : idx < 3 ? 3.5 : 2.5, opacity: idx === 0 ? 0.9 : idx < 3 ? 0.7 : 0.4 }));
            })) : (React.createElement(Polyline, { key: "main-route", positions: routePath.map(nodeId => {
                    const node = routeCache.nodes.get(nodeId);
                    return node ? [node.lat, node.lon] : [0, 0];
                }).filter((coord) => coord[0] !== 0 || coord[1] !== 0), color: ROUTE_COLORS[0], weight: 5, opacity: 0.8 })))),
            routePath && routePath.length > 0 && routeCache ? ((selectedRouteIndex !== null && alternativeRoutes[selectedRouteIndex]
                ? alternativeRoutes[selectedRouteIndex].stops
                : routeStops).map((stopName, index) => {
                const normName = normalizeName(stopName);
                const stationPoint = routeCache.stationPoints.find(sp => sp.norm === normName);
                if (!stationPoint)
                    return null;
                const currentStops = selectedRouteIndex !== null && alternativeRoutes[selectedRouteIndex]
                    ? alternativeRoutes[selectedRouteIndex].stops
                    : routeStops;
                const isFirstOrLast = index === 0 || index === currentStops.length - 1;
                const markerIcon = divIcon({
                    html: `<div style="font-size:14px;">${isFirstOrLast ? '🔵' : '🟢'}</div>`,
                    className: 'custom-marker',
                    iconSize: [14, 14],
                    iconAnchor: [10, 10]
                });
                return (React.createElement(Marker, { key: `${stopName}-${index}`, position: [stationPoint.lat, stationPoint.lon], icon: markerIcon },
                    React.createElement(Popup, null,
                        React.createElement("strong", null, stopName))));
            })) : (selectedStationsCoords.map((station, index) => {
                const isFirst = station.name === firstStation;
                const isLast = station.name === lastStation;
                const isVia = station.name === routeVia;
                const markerIcon = divIcon({
                    html: `<div style="font-size:14px;">${isFirst || isLast ? '🔵' : isVia ? '🟡' : '🟢'}</div>`,
                    className: 'custom-marker',
                    iconSize: [14, 14],
                    iconAnchor: [10, 10]
                });
                return (React.createElement(Marker, { key: `${station.name}-${index}`, position: [station.lat, station.lon], icon: markerIcon },
                    React.createElement(Popup, null,
                        React.createElement("strong", null, station.name))));
            })))));
}
